import { inject } from '@angular/core'
import { catchError, map, of, tap } from 'rxjs'
import { AppSettingsService } from '../services/app-settings.service'
import { ApplicationInsightsService } from '../services/insights/application-insights.service'

export function initializeAppSettings() {
    const appSettingsService = inject(AppSettingsService)
    const applicationInsightsService = inject(ApplicationInsightsService)

    return appSettingsService.getAppSettings().pipe(
        tap(({ appInsightsConnectionString }) => {
            applicationInsightsService.initialize(appInsightsConnectionString)
        }),
        map(() => undefined),
        catchError(() => of(undefined))
    )
}
